import React from "react"
import IconColumn from "./IconColumn"
import SignUpField from '../Footer/SignUpField'
import materialsConfig from "../../configs/materials-config"
import sectionConfig from "../../configs/section-config"

const Materials = () => {
  const { title, description } = sectionConfig["materials"]
  
  return (
    <div>
      <div className="section-header">
        <div className="title"><h1>{title.toUpperCase()}</h1></div>
        <div className="description">
          <p>{description}</p>
        </div>
        </div>
      <div className="section-description">
        <div className="materials-subscribe">
          <p>Sign up for updates and releases</p>
          <SignUpField
            label="Subscribe" 
            message="materials subscription" 
            subject="Materials"/>
        </div>
      </div>
      <IconColumn config={materialsConfig} />
    </div>
  )
}

export default Materials



// WEBPACK FOOTER //
// ./src/components/Materials/Materials.js